var _defs, _polygon, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProhibition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.48 23.56 99.28 65.32 52.12 65.39 67.6 51.72 99.48 23.56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.27,20.5H104.5l-.23,47.33a2.5,2.5,0,0,1-2.49,2.49L48,70.39V222.77A12.74,12.74,0,0,0,60.73,235.5H195.27A12.74,12.74,0,0,0,208,222.77V33.23A12.74,12.74,0,0,0,195.27,20.5Zm-4.79,106.75a2.5,2.5,0,0,1-1.73,2.38l-15.21,5v26.13a9,9,0,0,1,3.24,15.56L180,189.39a2.49,2.49,0,0,1-.47,2.14,2.46,2.46,0,0,1-2,1h-13a2.5,2.5,0,0,1-2.43-3.1l3.22-13.11a9,9,0,0,1,3.21-15.55V136.22l-6.32,2.06v21.44a2.51,2.51,0,0,1-.78,1.82c-8.18,7.78-21,12.43-34.21,12.43s-26-4.65-34.22-12.43a2.51,2.51,0,0,1-.78-1.82V137.79l-25-8.16a2.49,2.49,0,0,1-1.72-2.38v-8.11a2.51,2.51,0,0,1,1.81-2.41l60-17.13a2.49,2.49,0,0,1,1.38,0l60,17.13a2.51,2.51,0,0,1,1.82,2.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.38,187.49h-6.65l2.26-9.22a8.14,8.14,0,0,0,2.13,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175,169.35a4,4,0,1,1-4-4A4,4,0,0,1,175,169.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.48,121v4.42l-11.94,3.89V127a2.51,2.51,0,0,0-1.85-2.42l-40.15-10.83a2.5,2.5,0,0,0-1.3,4.83l38.3,10.33V131L128,144.19,70.49,125.44V121L128,104.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.22,139.91v18.72c-7.31,6.49-18.42,10.34-30,10.34s-22.69-3.85-30-10.34V139.42l30,9.78a2.59,2.59,0,0,0,1.56,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibition);
export default __webpack_public_path__ + "static/media/prohibition.ced94e0178c5b0a73280553139fdebdd.svg";
export { ForwardRef as ReactComponent };